/* eslint-disable import/no-unresolved */
import {
    useEffect, useLayoutEffect, useState,
} from 'react';
import { Button, Select, SelectOption } from 'appkit-react';
import { Col, Row } from 'react-bootstrap';
import { useHistory, useLocation } from 'react-router-dom';
import { useQuery, useReactiveVar } from '@apollo/client';

import {
    showDataReconVar, showReportMenuVar, tenantIdVar,
    selectValueVar,
    activeDataReconMenuVar,
    showDataReconMenusVar,
    getUserInfoVar,
    moduleIdVar,
    currentLeftMenuVar,
    leftNavigationItemsVar,
} from 'Apollo/config';
import { GET_MODULES, GET_REGULATORS } from 'Apollo/Queries';
import homeImage from 'assets/images/landing-page-digital-technology.png';
import Loader from 'views/Shared/components/Loader';
import ErrorView from 'views/Shared/components/ErrorView';
import logo from 'assets/images/pwc-new-logo.png';
import { setSelectedTenant as setStorageSelectedTenant } from 'views/Auth/AuthHelper';
import { ModuleEnum, ModuleIdEnum, RegulationEnum } from '../../constants/index';
import './landingpage.scss';

const LandingPage = () => {
    const history = useHistory();
    const location = useLocation();
    const defaultTenant = useReactiveVar(tenantIdVar);
    const defaultModule = useReactiveVar(moduleIdVar);
    const [selectedTenant, setSelectedTenant] = useState(defaultTenant);
    const [selectedModule, setSelectedModule] = useState(defaultModule);
    const [selectedReportGroup, setSelectedReportGroup] = useState('');
    const [regulation, setRegulation] = useState('');
    const [module, setModule] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [isError, setIsError] = useState(false);
    const userInfo = useReactiveVar(getUserInfoVar);
    const [size, setSize] = useState([0, 0]);

    useLayoutEffect(() => {
        function updateSize() {
            setSize([window.innerWidth, window.innerHeight]);
        }
        window.addEventListener('resize', updateSize);
        updateSize();
        return () => window.removeEventListener('resize', updateSize);
    }, []);

    /* apollo query to fetch regulators */
    const regulators = useQuery(GET_REGULATORS);

    /* apollo query to fetch modules */
    const modules = useQuery(GET_MODULES);

    /* function to navigate to respective module component based on module and regulation selected */
    const navigateToProjects = () => {
        if (module === ModuleEnum.RULEENGINE && regulation === RegulationEnum.FRY7Q) {
            showReportMenuVar(true);
            showDataReconVar(true);
            currentLeftMenuVar(ModuleEnum.RULEENGINE);
            history.push(
                {
                    pathname: '/fry7q',
                    state: {
                        regulation,
                    },
                },
            );
        }
        if (module === ModuleEnum.RULEENGINE && regulation === RegulationEnum.FRY9C) {
            showReportMenuVar(true);
            showDataReconVar(true);
            currentLeftMenuVar(ModuleEnum.RULEENGINE);
            history.push(
                {
                    pathname: '/fry9c',
                    state: {
                        regulation,
                    },
                },
            );
        }
        if (module === ModuleEnum.RULEENGINE && regulation === RegulationEnum.FFIEC031) {
            showReportMenuVar(true);
            showDataReconVar(true);
            currentLeftMenuVar(ModuleEnum.RULEENGINE);
            history.push(
                {
                    pathname: '/ffiec031',
                    state: {
                        regulation,
                    },
                },
            );
        }
        if (module === ModuleEnum.RULEENGINE && regulation === RegulationEnum.FFIEC041) {
            showReportMenuVar(true);
            showDataReconVar(true);
            currentLeftMenuVar(ModuleEnum.RULEENGINE);
            history.push(
                {
                    pathname: '/ffiec041',
                    state: {
                        regulation,
                    },
                },
            );
        }
        if (module === ModuleEnum.RULEENGINE && regulation === RegulationEnum.METRO2) {
            showReportMenuVar(true);
            showDataReconVar(true);
            currentLeftMenuVar(ModuleEnum.RULEENGINE);
            history.push(
                {
                    pathname: '/metro2',
                    state: {
                        regulation,
                    },
                },
            );
        }
        if (module === ModuleEnum.RULEENGINE && regulation === RegulationEnum.FFIEC009) {
            showReportMenuVar(true);
            showDataReconVar(true);
            currentLeftMenuVar(ModuleEnum.RULEENGINE);
            history.push(
                {
                    pathname: '/FFIEC009',
                    state: {
                        regulation,
                    },
                },
            );
        }
        if (module === ModuleEnum.RULEENGINE && regulation === RegulationEnum.FR2052A) {
            showReportMenuVar(true);
            showDataReconVar(true);
            currentLeftMenuVar(ModuleEnum.RULEENGINE);
            history.push(
                {
                    pathname: '/fr2052a',
                    state: {
                        regulation,
                    },
                },
            );
        }
        if (module === ModuleEnum.DATARECONCILIATION) {
            showDataReconVar(true);
            showDataReconMenusVar(true);
            activeDataReconMenuVar('home');
            currentLeftMenuVar(ModuleEnum.DATARECONCILIATION);
            history.push(
                {
                    pathname: '/data-recon-home',
                    state: {
                        tenantId: selectedTenant,
                    },
                },
            );
        }
        if (module === 'OCR' && regulation === 'OCR') {
            window.open('http://u2zsixmvsdlv001.pwcglb.com/ocr');
        }
        if (module === ModuleEnum.CROSSREPORTVALIDATION) {
            currentLeftMenuVar('2');
            history.push('/cross-report');
        }
        if (module === ModuleEnum.TRENDANALYTICS && userInfo.getUser.moduleIds.includes(selectedModule)) {
            window.open(process.env.REACT_APP_TRENDS_SERVICE_URL);
        }
        if (selectedModule === ModuleIdEnum.DEMO && userInfo.getUser.moduleIds.includes(selectedModule)) {
            history.push('/demo');
        }
        if (selectedModule === ModuleIdEnum.BENCHMARK && userInfo.getUser.moduleIds.includes(selectedModule)) {
            history.push('/benchmark2');
        }
    };

    /* callback function on regulation selected */
    const onSelectRegulation = value => {
        if (regulators.data) {
            const result = regulators.data.getRegulators.find(r => r.regulatorId === value);
            if (result) {
                selectValueVar(result);
                setRegulation(result.displayName);
            }
        }
    };

    /* callback function on Module selected */
    const onSelectModule = value => {
        if (modules.data) {
            const result = modules.data.getModules.find(r => r.moduleId === value);
            if (result) {
                setModule(result.moduleDisplayName);
            }
            moduleIdVar(value);
        }
    };

    useEffect(() => {
        onSelectModule(selectedModule);
    }, [selectedModule, modules]);

    /* side effect when loading or regulators.loading is true */
    useEffect(() => {
        if (regulators.loading) {
            setIsLoading(true);
        } else {
            setIsLoading(false);
        }
    }, [regulators.loading]);

    /* side effect when error, regulators.error, modules.error is true */
    useEffect(() => {
        if (regulators.error || modules.error) {
            setIsError(true);
        } else {
            setIsError(false);
        }
    }, [regulators.error, modules.error]);

    /* side effect when location is changed */
    useEffect(() => {
        showDataReconMenusVar(false);
    }, [location]);

    useEffect(() => {
        tenantIdVar(selectedTenant);
        setStorageSelectedTenant(selectedTenant);
    }, [selectedTenant]);

    useEffect(() => {
        if (defaultTenant) {
            setSelectedTenant(defaultTenant);
        }
    }, [defaultTenant]);

    useEffect(() => {
        leftNavigationItemsVar([]);
    }, []);

    return (
        <div className="true-comply-landing-page" style={{ height: '95vh' }}>
            {isLoading && <Loader />}
            {isError && <ErrorView />}
            {(!isLoading && !isError) && (
                <>
                    <Row>
                        <Col md={1}>
                            <div style={{ height: '70px' }}>
                                <img src={logo} className="true-comply-landing-page-logo" alt="logo Icon" />
                            </div>
                        </Col>
                        <Col md={5}>
                            <div
                                className="true-comply-landing-page-welcome_text"
                            >
                                <span>Welcome to Report Inspector,</span>
                                <br />
                                <span>{userInfo?.getUser?.firstName}</span>
                                <span>.</span>
                            </div>
                            <div className="welcome-text-wrapper">
                                <div
                                    className="true-comply-landing-page-sub_text"
                                >
                                    The Report Inspector provides an insightful dashboard
                                    that can support in the identification of outliers
                                    for targeted sampling and has the ability to benchmark across peers and other financial institutions based on publicly available data.
                                </div>
                            </div>
                            <div className="true-comply-landing-page_form">
                                <div className="form-label a-h6">ORGANIZATION</div>
                                <Select
                                    onSelect={value => setSelectedTenant(value)}
                                    value={selectedTenant}
                                >
                                    {
                                        userInfo?.getUser
                                        && userInfo.getUser.userTenants
                                        && userInfo.getUser.userTenants.map(({ tenantId, name }) => (
                                            <SelectOption key={tenantId} value={tenantId}>{name}</SelectOption>
                                        ))
                                    }
                                </Select>
                                <div>
                                    {selectedTenant && (
                                        <div>
                                            <div className="form-label a-h6">MODULE</div>
                                            <Select
                                                onSelect={
                                                    value => {
                                                        setSelectedModule(value);
                                                        onSelectModule(value);
                                                    }
                                                }
                                                value={selectedModule}
                                                className="form-select"
                                                disabled={(!(userInfo?.getUser?.moduleIds) || (userInfo?.getUser?.moduleIds.length === 0))}
                                            >
                                                {userInfo?.getUser?.moduleIds && userInfo?.getUser?.moduleIds.length > 0
                                                    ? modules.data
                                                    && modules.data.getModules
                                                        .filter(m => userInfo?.getUser?.moduleIds.includes(m.moduleId))
                                                        .map(
                                                            ({ moduleId, moduleDisplayName }) => (
                                                                <SelectOption
                                                                    key={moduleId}
                                                                    value={moduleId}
                                                                >
                                                                    {moduleDisplayName}
                                                                </SelectOption>
                                                            ),
                                                        )
                                                    : null}
                                            </Select>
                                        </div>
                                    )}
                                </div>
                                {(!(userInfo?.getUser?.moduleIds) || (userInfo?.getUser?.moduleIds.length === 0)) && (
                                    <div style={{ color: 'red', marginTop: '2rem' }}>
                                        No modules currently available. Please contact Admin
                                    </div>
                                )}

                                <div>
                                    {selectedModule === ModuleIdEnum.RULEENGINE && (
                                        <div>
                                            <div className="form-label a-h6">REPORT</div>
                                            <Select
                                                onSelect={
                                                    value => {
                                                        setSelectedReportGroup(value);
                                                        onSelectRegulation(value);
                                                    }
                                                }
                                                value={selectedReportGroup}
                                            >
                                                {
                                                    regulators.data
                                                    && regulators.data.getRegulators
                                                        .map(
                                                            ({ regulatorId, displayName }) => (
                                                                <SelectOption
                                                                    key={regulatorId}
                                                                    value={regulatorId}
                                                                >
                                                                    {displayName}
                                                                </SelectOption>
                                                            ),
                                                        )
                                                }
                                            </Select>
                                        </div>
                                    )}
                                </div>

                                <div>
                                    {(selectedModule === ModuleIdEnum.DATARECONCILIATION
                                        || selectedModule === ModuleIdEnum.CROSSREPORTVALIDATION
                                        || selectedModule === ModuleIdEnum.TRENDANALYTICS
                                        || selectedModule === ModuleIdEnum.DEMO
                                        || selectedModule === ModuleIdEnum.BENCHMARK
                                        || selectedReportGroup) && (
                                        <Button
                                            size="lg"
                                            className="btn-continue"
                                            onClick={navigateToProjects}
                                            style={{ marginBottom: '2rem' }}
                                        >
                                            CONTINUE
                                        </Button>
                                    )}
                                </div>
                            </div>
                        </Col>
                        <Col md={6}>
                            <div className="true-comply-landing-group_image">
                                <img src={homeImage} alt="Group_image" />
                            </div>
                        </Col>
                    </Row>
                </>
            )}
        </div>
    );
};

export default LandingPage;